import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup
} from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const MuteTicketModal = ({ open, onClose, ticket }) => {
  const [duration, setDuration] = useState("28800");
  const [loading, setLoading] = useState(false);

  const handleMute = async () => {
    setLoading(true);
    try {
      const payload = {
        muted: true,
        ...(duration === "forever"
          ? {}
          : { durationSeconds: Number(duration) })
      };
      const { data } = await api.post(`/tickets/${ticket.id}/mute`, payload);

      if (data.synced) {
        toast.success(i18n.t("ticketMute.synced"));
      } else {
        toast.warn(i18n.t("ticketMute.localOnly"));
      }
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n.t("ticketMute.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{i18n.t("ticketMute.description")}</DialogContentText>
        <RadioGroup
          value={duration}
          onChange={event => setDuration(event.target.value)}
        >
          <FormControlLabel
            value="28800"
            control={<Radio color="primary" />}
            label={i18n.t("ticketMute.eightHours")}
          />
          <FormControlLabel
            value="604800"
            control={<Radio color="primary" />}
            label={i18n.t("ticketMute.oneWeek")}
          />
          <FormControlLabel
            value="forever"
            control={<Radio color="primary" />}
            label={i18n.t("ticketMute.forever")}
          />
        </RadioGroup>
        <DialogContentText>{i18n.t("ticketMute.syncWarning")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {i18n.t("ticketMute.cancel")}
        </Button>
        <Button
          onClick={handleMute}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {i18n.t("ticketMute.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MuteTicketModal;
